import { ObjectivesRest } from "@/services/rest/objectives.rest";
import { BehaviorSubject } from "rxjs";

export class NewObjectiveService {
  constructor(
    private _objectives = new ObjectivesRest(),
    private _courses = new ObjectivesRest(),

  ) {}
  private objective$ = new BehaviorSubject<any>([]);
  objective = this.objective$.asObservable();
  private course$ = new BehaviorSubject<any>([]);
  course = this.course$.asObservable();
  getObjectiveById(chapterId: string, trailId: string): void {
    this._objectives
      .getObjectiveById(chapterId, trailId)
      .pipe()
      .subscribe({
        next: (response) => {
          this.objective$.next(response);
        },
      });
  }
  getCourseById(chapterId: string, trailId: string): void {
    this._courses
      .getObjectiveById(chapterId, trailId)
      .pipe()
      .subscribe({
        next: (response) => {
          this.objective$.next(response);
        },
      });
  }
}
